<template>
    <div class="qrCode">
        <div class="tit" v-text="QRtitle"></div>
        <img :src="QRUrl" alt="" :width="width" :height="height" />
    </div>
</template>

<script>
import QRCode from "qrcode"
export default {
    name: "QRCode",
    props: {
        QRtitle: {
            type: String,
            default: "标题"
        },
        content: {
            type: String,
            default: "二维码"
        },
        width: {
            type: String,
            default: "150"
        },
        height: {
            type: String,
            default: "150"
        },
        codeName: {
            type: String,
            default: "二维码"
        },
        load: {
            type: Boolean,
            default: true
        },
        view: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            QRlink: '',
            QRUrl: ''
        }
    },
    created () {
        this.getQRcode()
    },
    methods: {
        getQRcode(){
            // 获取当前页面路径
            this.QRlink = window.location.href.split('tyjr')[0] + 'tyjr' + this.$route.fullPath
            QRCode.toDataURL(this.QRlink, { errorCorrectionLevel: 'L', margin: 2, width: 150 }, (err, url) => {
                if (err) throw err
                this.QRUrl= url
            })
        }
    },
}
</script>

<style lang="less" scoped>
.qrCode {
    width: 200px;
    margin: 20px auto;
    .tit {
        font-size: 14px;
        text-align: center;
        line-height: 1.6;
    }
    img {
        display: block;
        margin: 0 auto;
    }
}
</style>